import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import Layout from "@/components/Layout";
import ScrollToTop from "@/components/ScrollToTop";

import Home from "@/pages/Home";
import Univers from "@/pages/Univers";
import Activities from "@/pages/Activities";
import ActivityDetail from "@/pages/ActivityDetail";
import Academy from "@/pages/Academy";
import StageDetail from "@/pages/StageDetail";
import Boutique from "@/pages/Boutique";
import Teachers from "@/pages/Teachers";
import News from "@/pages/News";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Cart from "@/pages/Cart";
import Dashboard from "@/pages/Dashboard";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Admin from "@/pages/Admin";
import AnimatorSpace from "@/pages/AnimatorSpace";
import AnimatorDeroules from "@/pages/AnimatorDeroules";
import Presentation from "@/pages/Presentation";
import Approche from "@/pages/Approche";
import Equipe from "@/pages/Equipe";
import Job from "@/pages/Job";
import MesFiches from "@/pages/MesFiches";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/notre-univers" element={<Univers />} />
                <Route path="/notre-univers/presentation" element={<Presentation />} />
                <Route path="/notre-univers/approche" element={<Approche />} />
                <Route path="/equipe" element={<Equipe />} />
                <Route path="/job" element={<Job />} />
                <Route path="/nos-activites" element={<Activities />} />
                <Route path="/nos-activites/:id" element={<ActivityDetail />} />
                <Route path="/academie" element={<Academy />} />
                <Route path="/academie/:id" element={<StageDetail />} />
                <Route path="/boutique" element={<Boutique />} />
                <Route path="/enseignants" element={<Teachers />} />
                <Route path="/mes-fiches" element={<MesFiches />} />
                <Route path="/actualites" element={<News />} />
                <Route path="/a-propos" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/connexion" element={<Login />} />
                <Route path="/inscription" element={<Register />} />
                <Route path="/panier" element={<Cart />} />
                <Route path="/mon-compte" element={<Dashboard />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/espace-animateur" element={<AnimatorSpace />} />
                <Route path="/espace-animateur/fiches" element={<AnimatorDeroules />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
